import classNames from "classnames";

import {
  LesionLine,
  combineSubtypes,
  subtypeOrSubtypesDiagnosis,
} from "shared/reducers/aiReducer";

import { useAppSelector } from "store/hooks";

const SubtypesAndMargin = ({
  lesionLine,
  showInconclusive,
}: {
  lesionLine: LesionLine;
  showInconclusive?: boolean;
}) => {
  const features = useAppSelector(({ sys }) => sys.features);

  const positive_subtypes = lesionLine.subtypes?.filter(
    (s) => s.diagnosis_result === "POSITIVE"
  );
  const inconclusive_subtypes = lesionLine.subtypes?.filter(
    (s) => s.diagnosis_result === "INCONCLUSIVE"
  );

  return (
    <>
      {(subtypeOrSubtypesDiagnosis(lesionLine) || lesionLine.margin_status) && (
        <span className="LesionLineType__subtypes">
          {!!positive_subtypes?.length && (
            <>
              <span
                className={classNames("LesionLineType__legend", {
                  "LesionLineType__legend--positive":
                    lesionLine?.diagnosis_name !== "Cyst" ||
                    features?.cystSubtypeROI,
                  "LesionLineType__legend--clear":
                    !features?.cystSubtypeROI &&
                    lesionLine?.diagnosis_name === "Cyst",
                })}
              >
                {combineSubtypes(positive_subtypes)}
              </span>
              {lesionLine.margin_status && (
                <code> ({lesionLine.margin_status} Margin)</code>
              )}
            </>
          )}
          {!!positive_subtypes?.length &&
            showInconclusive &&
            !!inconclusive_subtypes?.length && <>, </>}
          {showInconclusive && !!inconclusive_subtypes?.length && (
            <>
              <span
                className={classNames("LesionLineType__legend", {
                  "LesionLineType__legend--inconclusive":
                    lesionLine?.diagnosis_name !== "Cyst" ||
                    features?.cystSubtypeROI,
                  "LesionLineType__legend--clear":
                    !features?.cystSubtypeROI &&
                    lesionLine?.diagnosis_name === "Cyst",
                })}
              >
                {combineSubtypes(inconclusive_subtypes, ", ")} (Inconclusive)
              </span>
            </>
          )}
        </span>
      )}
    </>
  );
};
export default SubtypesAndMargin;
